import RentBondLogo from 'app/assets/icons/rentbond-logo.png'
import { Box } from 'app/components/design-system-components'
import RentbondLink from 'app/Integrations/components/RentBond/components/RentbondLink'

const defaultText = (
  <>
    Make your move a breeze with Australia's leading bond loan. It's quick, easy
    and flexible. <RentbondLink textInLink="learn more" />
  </>
)

function RentBondLogoAndDesc({ text = defaultText }) {
  return (
    <Box lineHeight="140%">
      <img src={RentBondLogo} alt="RentBond" style={{ maxWidth: '165px' }} />
      <Box mt={5}>{text}</Box>
    </Box>
  )
}

export default RentBondLogoAndDesc
